export const recaptcha = '6LcaZigTAAAAAIjIAg4Sto4Oawn_mub5saiN7xfY'


// WEBPACK FOOTER //
// ./src/constants/recaptcha.js